/**
 * @enum {enumTheme} An enumeration of different themes that can be applied to the UI
 */
export enum enumTheme {
  Default = 'Default', // the 'Default' theme
  UsOpen = 'UsOpen', // the 'US Open' theme
  Wimbledon = 'Wimbledon' // the 'Wimbledon' theme
}
